import { Input } from "@mantine/core";

import Typography from "_components/atoms/typography";
import useStyles  from "_styles/pages/auth";

const component = props => {
	const {
		value,
		numInputs = 6,
		handleChange,
		// error = false,
		errorMsg,
		type = "number",
		id,
		inputProps
	} = props;

	const { classes } = useStyles ( );

	return (
		<div className = { classes.otpInputContainet }>

			<Input
				autoFocus
				fullWidth
				autoComplete    = "off"
				className       = { classes.root }
				classNames      = { {
					input: classes.tvinput
					// root            : classes.inputDisableSpinner,
					// focused         : classes.cssFocused,
					// notchedOutline  : `${ classes.notchedOutline } outline`,
					// input           : `${ classes.inputTag } textCenter`,
					// adornedStart    : classes.adornedStart,
					// inputAdornedEnd : classes.adornedStart,
					// error           : classes.inputError
				} }
				error           = { Boolean ( errorMsg ) }
				id              = { id }
				InputLabelProps = { {
					classes: {
						root: classes.label
					}
				} }
				inputProps      = { inputProps }
				margin          = "dense"
				mb              = "md"
				onChange        = { e => handleChange ( e.target.value ) }
				onInput         = { e => {
					if ( type === "number" )
						e.target.value = Math.max ( 0, parseInt ( e.target.value ) ).toString ().slice ( 0, numInputs );
					else
						e.target.value =  e.target.value.toString ().slice ( 0, numInputs );

				} }
				type            = { type }
				value           = { value }
				variant         = "outline"
			/>

			{
				errorMsg ? (
					<Typography
						className = { classes.otpError }
						title     = { errorMsg }
					/>
				) : null
			}
		</div>
	);
};

export default component;